import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, inject, viewChild, contentChild, model } from '@angular/core';
import { FocusTrapperFactory } from '../../../components/focus/focus-trapper-factory';
import { MenuPanelItem } from '../../../domain/menu.domain';
import { MobileFlyoutMenuNavContainer } from './mobile-flyout-menu.domain';

@Component({
  selector: 'td-wb-mobile-flyout-menu-nav',
  templateUrl: 'mobile-flyout-menu-nav.component.html',
  styleUrls: ['mobile-flyout-menu-nav.component.scss'],
  imports: [
    NgTemplateOutlet
  ],
  host: {
    '[style.transitionDuration.ms]': 'styleTransitionDuration',
    '[style.transform]': 'styleTransform',
    '[attr.aria-hidden]': 'attrAriaHidden',
    '[style.display]': 'menuDisplay'
  }
})
export class MobileFlyoutMenuNavComponent implements OnDestroy {
  private readonly focusTrapperFactory = inject(FocusTrapperFactory);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  static TRANSITION_DURATION: number = 250;

  readonly container = viewChild<ElementRef>('menuContainer');

  readonly opened = model(false);

  readonly content = contentChild(TemplateRef);

  get menuDisplay(): string { return this.opened() ? 'block' : 'none'; }

  styleTransitionDuration: number = MobileFlyoutMenuNavComponent.TRANSITION_DURATION;

  styleTransform: string = 'translate3d(-100%, 0, 0)';

  attrAriaHidden: string = 'true';

  menu: MenuPanelItem;

  private overlayRefContainer: MobileFlyoutMenuNavContainer;

  ngOnDestroy(): void {
    this.dispose();
  }

  open(menu?: MenuPanelItem): void {
    if (!this.opened()) {
      this.menu = menu;
      this.overlayRefContainer = new MobileFlyoutMenuNavContainer(this.container().nativeElement, this.focusTrapperFactory);
      this.toggle(true);
    }
  }

  close(): void {
    this.dispose();
    return this.toggle(false);
  }

  toggle(isOpen: boolean = !this.opened()): void {
    if (this.opened() !== isOpen) {
      this.opened.set(isOpen);

      this.styleTransform = this.opened() ? 'none' : 'translate3d(-100%, 0, 0)';
      this.attrAriaHidden = this.opened() ? 'false' : 'true';

      this.changeDetectorRef.markForCheck();
    }
  }

  swipeLeft(): void {
    if (this.opened()) {
      this.close();
    }
  }

  stopAnimation(): void {
    this.styleTransitionDuration = 0;
  }

  startAnimation(): void {
    this.styleTransitionDuration = MobileFlyoutMenuNavComponent.TRANSITION_DURATION;
  }

  moveTo(left: number): void {
    this.styleTransform = `translate3d(${left}px, 0, 0)`;
  }

  private dispose(): void {
    if (this.overlayRefContainer !== undefined) {
      this.overlayRefContainer.destroy();
      this.overlayRefContainer = undefined;
    }
  }
}
